module.exports = __webpack_public_path__ + "img/happy-computer.87fd8e68.png";